import React from 'react';
import { IconProps } from '../types';
const MinecraftMusicDiscWard: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="5" y="3" width="1" height="1" fill="rgba(33, 33, 33, 255)" />
<rect x="6" y="3" width="1" height="1" fill="rgba(33, 33, 33, 255)" />
<rect x="7" y="3" width="1" height="1" fill="rgba(33, 33, 33, 255)" />
<rect x="8" y="3" width="1" height="1" fill="rgba(33, 33, 33, 255)" />
<rect x="9" y="3" width="1" height="1" fill="rgba(33, 33, 33, 255)" />
<rect x="2" y="4" width="1" height="1" fill="rgba(33, 33, 33, 255)" />
<rect x="3" y="4" width="1" height="1" fill="rgba(33, 33, 33, 255)" />
<rect x="4" y="4" width="1" height="1" fill="rgba(33, 33, 33, 255)" />
<rect x="5" y="4" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="6" y="4" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="8" y="4" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(33, 33, 33, 255)" />
<rect x="11" y="4" width="1" height="1" fill="rgba(33, 33, 33, 255)" />
<rect x="12" y="4" width="1" height="1" fill="rgba(33, 33, 33, 255)" />
<rect x="1" y="5" width="1" height="1" fill="rgba(33, 33, 33, 255)" />
<rect x="2" y="5" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="3" y="5" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="4" y="5" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="5" y="5" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(81, 81, 81, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(81, 81, 81, 255)" />
<rect x="9" y="5" width="1" height="1" fill="rgba(81, 81, 81, 255)" />
<rect x="10" y="5" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="11" y="5" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="12" y="5" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="13" y="5" width="1" height="1" fill="rgba(33, 33, 33, 255)" />
<rect x="0" y="6" width="1" height="1" fill="rgba(33, 33, 33, 255)" />
<rect x="1" y="6" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="2" y="6" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="3" y="6" width="1" height="1" fill="rgba(81, 81, 81, 255)" />
<rect x="4" y="6" width="1" height="1" fill="rgba(81, 81, 81, 255)" />
<rect x="5" y="6" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(0, 107, 87, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(0, 107, 87, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(0, 107, 87, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="10" y="6" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="11" y="6" width="1" height="1" fill="rgba(81, 81, 81, 255)" />
<rect x="12" y="6" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="13" y="6" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="14" y="6" width="1" height="1" fill="rgba(33, 33, 33, 255)" />
<rect x="0" y="7" width="1" height="1" fill="rgba(33, 33, 33, 255)" />
<rect x="1" y="7" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="2" y="7" width="1" height="1" fill="rgba(81, 81, 81, 255)" />
<rect x="3" y="7" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="4" y="7" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="5" y="7" width="1" height="1" fill="rgba(0, 107, 87, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(0, 107, 87, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(38, 38, 38, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(142, 198, 0, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(142, 198, 0, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="11" y="7" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="12" y="7" width="1" height="1" fill="rgba(81, 81, 81, 255)" />
<rect x="13" y="7" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="14" y="7" width="1" height="1" fill="rgba(33, 33, 33, 255)" />
<rect x="0" y="8" width="1" height="1" fill="rgba(33, 33, 33, 255)" />
<rect x="1" y="8" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="2" y="8" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="3" y="8" width="1" height="1" fill="rgba(81, 81, 81, 255)" />
<rect x="4" y="8" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(142, 198, 0, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(142, 198, 0, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(142, 198, 0, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(81, 81, 81, 255)" />
<rect x="11" y="8" width="1" height="1" fill="rgba(81, 81, 81, 255)" />
<rect x="12" y="8" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="13" y="8" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="14" y="8" width="1" height="1" fill="rgba(33, 33, 33, 255)" />
<rect x="0" y="9" width="1" height="1" fill="rgba(33, 33, 33, 255)" />
<rect x="1" y="9" width="1" height="1" fill="rgba(38, 38, 38, 255)" />
<rect x="2" y="9" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="3" y="9" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(81, 81, 81, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(81, 81, 81, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(81, 81, 81, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="11" y="9" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="12" y="9" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="13" y="9" width="1" height="1" fill="rgba(38, 38, 38, 255)" />
<rect x="14" y="9" width="1" height="1" fill="rgba(33, 33, 33, 255)" />
<rect x="1" y="10" width="1" height="1" fill="rgba(17, 17, 17, 255)" />
<rect x="2" y="10" width="1" height="1" fill="rgba(38, 38, 38, 255)" />
<rect x="3" y="10" width="1" height="1" fill="rgba(38, 38, 38, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(38, 38, 38, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(64, 64, 64, 255)" />
<rect x="10" y="10" width="1" height="1" fill="rgba(38, 38, 38, 255)" />
<rect x="11" y="10" width="1" height="1" fill="rgba(38, 38, 38, 255)" />
<rect x="12" y="10" width="1" height="1" fill="rgba(38, 38, 38, 255)" />
<rect x="13" y="10" width="1" height="1" fill="rgba(17, 17, 17, 255)" />
<rect x="2" y="11" width="1" height="1" fill="rgba(17, 17, 17, 255)" />
<rect x="3" y="11" width="1" height="1" fill="rgba(17, 17, 17, 255)" />
<rect x="4" y="11" width="1" height="1" fill="rgba(17, 17, 17, 255)" />
<rect x="5" y="11" width="1" height="1" fill="rgba(38, 38, 38, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(38, 38, 38, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(38, 38, 38, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(38, 38, 38, 255)" />
<rect x="9" y="11" width="1" height="1" fill="rgba(38, 38, 38, 255)" />
<rect x="10" y="11" width="1" height="1" fill="rgba(17, 17, 17, 255)" />
<rect x="11" y="11" width="1" height="1" fill="rgba(17, 17, 17, 255)" />
<rect x="12" y="11" width="1" height="1" fill="rgba(17, 17, 17, 255)" />
<rect x="5" y="12" width="1" height="1" fill="rgba(17, 17, 17, 255)" />
<rect x="6" y="12" width="1" height="1" fill="rgba(17, 17, 17, 255)" />
<rect x="7" y="12" width="1" height="1" fill="rgba(17, 17, 17, 255)" />
<rect x="8" y="12" width="1" height="1" fill="rgba(17, 17, 17, 255)" />
<rect x="9" y="12" width="1" height="1" fill="rgba(17, 17, 17, 255)" />
</svg>);
export default MinecraftMusicDiscWard;